import CommonLayout from "../layouts/common";
import OnboardingLayout from "../layouts/onboarding";
import ManageTripsLayout from "../layouts/manageTrips";
import { Default_Routes } from "./default/default.routes";
import { ManageTrips_Routes } from "./manage-trips/manage-trips.routes";
import { Onboarding_Routes } from "./onboarding/onboarding.routes";
import { Profile_Routes } from "./profile/profile.routes";
import { TripManagement_Routes } from "./trip-management/tripManagement.routes";
var Web_Routes = [
    {
        PATH: "onboarding/*",
        SUB_ROUTES: Onboarding_Routes,
        LAYOUT: OnboardingLayout,
    },
    {
        PATH: "trip/*",
        SUB_ROUTES: TripManagement_Routes,
        LAYOUT: CommonLayout,
    },
    {
        PATH: "profile/*",
        SUB_ROUTES: Profile_Routes,
        LAYOUT: CommonLayout,
    },
    {
        PATH: "manage-trips/*",
        SUB_ROUTES: ManageTrips_Routes,
        LAYOUT: ManageTripsLayout,
    },
    {
        PATH: "*",
        SUB_ROUTES: Default_Routes,
        LAYOUT: CommonLayout,
    },
];
export default Web_Routes;
